<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" v-if="mode === 'view'">
            <div class="row mb-2">
              <div class="col-sm-8"></div>
              <div class="col-sm-4">
                <div class="text-sm-right"></div>
              </div>
            </div>
            <div class="form-group row mb-4" v-if="model.vendor_partners">
              <label class="col-form-label col-lg-2">รหัสผู้ขาย</label>
              <label class="col-form-label col-lg-8">{{
                model.vendor_partners.findIndex(el => el.partner === 'OFM') >= 0
                  ? model.vendor_partners[
                      model.vendor_partners.findIndex(
                        el => el.partner === 'OFM'
                      )
                    ].code
                  : ''
              }}</label>
            </div>
            <div class="form-group row mb-4" v-if="model.vendor_partners">
              <label class="col-form-label col-lg-2">รหัสผู้ขาย (JDA)</label>
              <label class="col-form-label col-lg-8">{{
                model.vendor_partners.findIndex(el => el.partner === 'JDA') >= 0
                  ? model.vendor_partners[
                      model.vendor_partners.findIndex(
                        el => el.partner === 'JDA'
                      )
                    ].code
                  : ''
              }}</label>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-lg-2">ชื่อผู้ขาย</label>
              <label class="col-form-label col-lg-8">
                <span class="badge-lang">TH</span>
                {{ model.display_name.th }}</label
              >
            </div>
            <div class="form-group row mb-3">
              <label class="col-form-label col-lg-2"></label>
              <label class="col-form-label col-lg-8">
                <span class="badge-lang">EN</span>
                {{
                  model.display_name.en === '' ? '-' : model.display_name.en
                }}</label
              >
            </div>
            <div class="form-group row">
              <label class="col-form-label col-lg-2">ประเภทผู้ขาย</label>
              <label class="col-form-label col-lg-8">
                <label
                  class="label"
                  :class="`label-${model.type.toLowerCase()}`"
                  >{{ model.type }}</label
                >
              </label>
            </div>
            <div class="form-group row">
              <label class="col-form-label col-lg-2">สถานะ</label>
              <label class="col-form-label col-lg-8">
                <label
                  class="label"
                  :class="`label-${model.status.toLowerCase()}`"
                  >{{ model.status }}</label
                >
              </label>
            </div>
            <div class="form-group row mb-4">
              <label class="col-form-label col-lg-2"
                >รายชื่อผู้ใช้งานระบบ</label
              >
              <div class="col-md-10">
                <div v-if="!isStatusDelete" class="row mb-4">
                  <div class="col-md-8"></div>
                  <div class="col-md-4 text-right">
                    <button
                      v-b-modal.modal-invite
                      type="button"
                      class="btn btn-success waves-effect waves-light"
                    >
                      <i class="bx bx-plus font-size-16 align-middle mr-2"></i>
                      Invite User
                    </button>
                  </div>
                </div>
                <div class="row table-responsive" v-if="model.users">
                  <b-table
                    class="table table-centered table-nowrap"
                    ref="usertable"
                    :empty-text="'ไม่พบข้อมูล'"
                    :show-empty="model.users.length == 0"
                    :bordered="true"
                    :items="model.users"
                    align="center"
                    v-bind:fields="filterUserTablefields"
                  >
                    <template v-slot:cell(index)="data">
                      <div class="text-right">
                        {{ (data.index + 1) | number }}
                      </div>
                    </template>
                    <template v-slot:cell(display_name_th)="data">
                      <div class="text-left">
                        {{
                          data.item.first_name.th + ' ' + data.item.last_name.th
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(display_name_en)="data">
                      <div class="text-left">
                        {{
                          data.item.first_name.en + ' ' + data.item.last_name.en
                        }}
                      </div>
                    </template>
                    <template v-slot:cell(status)="data">
                      <span
                        v-if="data.value"
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(isPimAdmin)="data">
                      <div class="text-center">
                        <b-form-checkbox
                          style="top: 0.5em"
                          v-model="data.item.role"
                          value="Admin"
                          unchecked-value="User"
                          @change="toggleCheckbox(data.index)"
                          :disabled="data.item.role == 'Admin'"
                          class="custom-checkbox-info mb-3"
                        ></b-form-checkbox>
                      </div>
                    </template>
                    <template v-slot:cell(action)="data">
                      <div class="button-items text-center">
                        <a
                          v-if="data.item.status !== 'Active'"
                          @click="resentEmail(data.item)"
                          class="btn btn-ico text-success"
                          title="Resent invite email"
                          ><i class="mdi mdi-email-sync"></i
                        ></a>
                        <!-- <a
                          @click="changeMode('edit', data.index, data.item)"
                          class="btn btn-ico text-warning"
                          title="Edit"
                          ><i class="bx bx-edit-alt"></i
                        ></a> -->
                        <a
                          @click="removeUser(data.item)"
                          class="btn btn-ico text-danger"
                          title="Remove"
                          ><i class="bx bx-trash"></i
                        ></a>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
            <div class="form-group mb-4 text-left">
              <div class="button-items">
                <button type="button" class="btn btn-light" @click="onBack()">
                  <i class="bx bx-arrow-back" />
                  Back
                </button>
              </div>
            </div>
          </div>
          <div class="card-body" v-if="mode === 'invite'">
            <validationObserver ref="addDataForm" tag="form">
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2">อีเมล</label>
                <div class="col-lg-5">
                  <validationProvider
                    v-slot="{ errors }"
                    name="Email"
                    :rules="{
                      dynamicRequired: ['กรุณาระบุข้อมูล'],
                      duplicateName: [
                        isValidate.user.email,
                        model.users.findIndex(
                          element => element.email === inviteUserModel.email
                        ) === -1
                          ? 'มีข้อมูลผู้ใช้งานนี้อยู่ในระบบแล้ว กรุณายืนยันเพื่อเพิ่มผู้ใช้งานใหม่'
                          : 'มีข้อมูลผู้ใช้งานรายนี้อยู่ใน Vendor นี้แล้ว',
                      ],
                    }"
                  >
                    <input
                      id="input_user_email"
                      name="input_user_email"
                      type="text"
                      class="form-control"
                      placeholder="ระบุอีเมล"
                      maxlength="150"
                      v-model="inviteUserModel.email"
                      :class="{
                        'is-invalid': errors && errors.length,
                        'is-valid':
                          !(errors && errors.length) && inviteUserModel.email,
                      }"
                      v-on:keyup="onValidateEmail($event)"
                    />
                    <div
                      v-if="
                        errors &&
                          errors.length &&
                          inviteUserModel.email &&
                          model.users.findIndex(
                            element => element.email === inviteUserModel.email
                          ) === -1
                      "
                      class="validate-invalid"
                    >
                      <span>{{ errors[0] }}</span>
                      <input
                        type="button"
                        class="btn btn-primary"
                        @click="onConfirmAddVendorUser()"
                        value="เพิ่มผู้ใช้งานระบบ"
                        style="margin-left: 1em"
                      />
                    </div>
                    <div
                      v-else-if="errors && errors.length"
                      class="validate-invalid"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validationProvider>
                </div>
              </div>
              <div class="form-group row mb-4" v-if="model.vendor_partners">
                <label class="col-form-label col-lg-2">รหัสผู้ขาย</label>
                <label class="col-form-label col-lg-8">{{
                  model.vendor_partners.findIndex(el => el.partner === 'OFM') >=
                  0
                    ? model.vendor_partners[
                        model.vendor_partners.findIndex(
                          el => el.partner === 'OFM'
                        )
                      ].code
                    : ''
                }}</label>
              </div>
              <div class="form-group row mb-4" v-if="model.vendor_partners">
                <label class="col-form-label col-lg-2">รหัสผู้ขาย (JDA)</label>
                <label class="col-form-label col-lg-8">{{
                  model.vendor_partners.findIndex(el => el.partner === 'JDA') >=
                  0
                    ? model.vendor_partners[
                        model.vendor_partners.findIndex(
                          el => el.partner === 'JDA'
                        )
                      ].code
                    : ''
                }}</label>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2">ชื่อผู้ขาย</label>
                <label class="col-form-label col-lg-8">{{
                  model.display_name.th
                }}</label>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2"></label>
                <label class="col-form-label col-lg-8">{{
                  model.display_name && model.display_name.en !== ''
                    ? model.display_name.en
                    : '-'
                }}</label>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2">ประเภทผู้ขาย</label>
                <label class="col-form-label col-lg-8">{{ model.type }}</label>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2">สถานะ</label>
                <label class="col-form-label col-lg-8">{{
                  model.status
                }}</label>
              </div>
              <div class="form-group row mb-4">
                <label class="col-form-label col-lg-2"
                  >ชื่อผู้ใช้งาน (ไทย)</label
                >
                <div class="col-lg-4">
                  <validationProvider
                    v-slot="{ errors }"
                    name="Thai First Name"
                    :rules="{
                      dynamicRequired: ['กรุณาระบุข้อมูล'],
                      validateThaiWithSpecialCharacters: true,
                    }"
                  >
                    <input
                      id="input_first_name_th"
                      name="input_first_name_th"
                      type="text"
                      class="form-control"
                      placeholder="ระบุชื่อ (ภาษาไทย)"
                      maxlength="100"
                      v-model="inviteUserModel.first_name.th"
                      :class="{
                        'is-invalid': errors && errors.length,
                        'is-valid':
                          !(errors && errors.length) &&
                          inviteUserModel.first_name.th,
                      }"
                    />
                    <div
                      v-if="errors && errors.length"
                      class="validate-invalid"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validationProvider>
                </div>
                <div class="col-lg-4">
                  <validationProvider
                    v-slot="{ errors }"
                    name="Thai Last Name"
                    :rules="{
                      dynamicRequired: ['กรุณาระบุข้อมูล'],
                      validateThaiWithSpecialCharacters: true,
                    }"
                  >
                    <input
                      id="input_last_name_th"
                      name="input_last_name_th"
                      type="text"
                      class="form-control"
                      placeholder="ระบุนามสกุล (ภาษาไทย)"
                      maxlength="100"
                      v-model="inviteUserModel.last_name.th"
                      :class="{
                        'is-invalid': errors && errors.length,
                        'is-valid':
                          !(errors && errors.length) &&
                          inviteUserModel.last_name.th,
                      }"
                    />
                    <div
                      v-if="errors && errors.length"
                      class="validate-invalid"
                    >
                      <span>{{ errors[0] }}</span>
                    </div>
                  </validationProvider>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="text-left">
                    <div class="button-items">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click="onBackToDetail()"
                      >
                        Back
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="text-right">
                    <div class="button-items">
                      <button type="submit" class="btn btn-primary">
                        Get Link
                      </button>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click="onConfirmClearInvite()"
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </validationObserver>
          </div>
          <div class="card-body" v-if="mode === 'edit'">
            <validationObserver ref="addDataForm" tag="form">
              <form @submit.prevent="onSubmit" @reset.prevent="onConfirmReset">
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">ชื่อ (ไทย)</label>
                  <label class="col-form-label col-lg-8">{{
                    model.users[indexEdit].first_name.th +
                      ' ' +
                      model.users[indexEdit].last_name.th
                  }}</label>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">ชื่อ (อังกฤษ)</label>
                  <label class="col-form-label col-lg-8">{{
                    model.users[indexEdit].first_name.en +
                      ' ' +
                      model.users[indexEdit].last_name.en
                  }}</label>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">อีเมล</label>
                  <label class="col-form-label col-lg-8">{{
                    model.users[indexEdit].email
                  }}</label>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">เบอร์โทรศัพท์</label>
                  <label
                    class="col-form-label col-lg-8"
                    v-if="
                      model.users[indexEdit].phone &&
                        model.users[indexEdit].phone.value
                    "
                    >{{
                      model.users[indexEdit].phone.value +
                        ' ' +
                        (model.users[indexEdit].phone &&
                        model.users[indexEdit].phone.extention
                          ? 'ต่อ ' + model.users[indexEdit].phone.extention
                          : '')
                    }}</label
                  >
                </div>

                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">สถานะ</label>
                  <div class="col-form-label col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Status"
                      :rules="{ dynamicRequired: ['กรุณาระบุข้อมูล'] }"
                    >
                      <div class="row col-lg-12">
                        <b-form-radio
                          v-model="model.users[indexEdit].status"
                          name="input_status"
                          class="custom-control custom-radio custom-radio-info mb-3"
                          value="Active"
                          style="margin-right: 10px"
                          >Active</b-form-radio
                        >
                        <b-form-radio
                          v-model="model.users[indexEdit].status"
                          name="input_status"
                          class="custom-control custom-radio custom-radio-info mb-3"
                          value="Inactive"
                          style="margin-right: 10px"
                          >Inactive</b-form-radio
                        >
                        <b-form-radio
                          v-model="model.users[indexEdit].status"
                          name="input_status"
                          class="custom-control custom-radio custom-radio-info mb-3"
                          value="Delete"
                          style="margin-right: 10px"
                          >Delete</b-form-radio
                        >
                      </div>
                      <div
                        v-if="errors && errors.length"
                        class="validate-invalid"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <label class="col-form-label col-lg-2">PIM Admin</label>
                  <div class="col-form-label col-lg-8">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Role"
                      :rules="{ dynamicRequired: ['กรุณาระบุข้อมูล'] }"
                    >
                      <div class="row col-lg-12">
                        <b-form-radio
                          v-model="model.users[indexEdit].role"
                          name="input_role"
                          class="custom-control custom-radio custom-radio-info mb-3"
                          value="Admin"
                          style="margin-right: 10px"
                          >Yes</b-form-radio
                        >
                        <b-form-radio
                          v-model="model.users[indexEdit].role"
                          name="input_role"
                          class="custom-control custom-radio custom-radio-info mb-3"
                          value="User"
                          style="margin-right: 10px"
                          >No</b-form-radio
                        >
                      </div>
                      <div
                        v-if="errors && errors.length"
                        class="validate-invalid"
                      >
                        <span>{{ errors[0] }}</span>
                      </div>
                    </validationProvider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="text-left">
                      <div class="button-items">
                        <button
                          type="button"
                          class="btn btn-secondary"
                          @click="onBackToDetail()"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="text-right">
                      <div class="button-items">
                        <button type="submit" class="btn btn-primary">
                          Save
                        </button>
                        <button type="reset" class="btn btn-secondary">
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </validationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->

    <b-modal
      id="modal-invite"
      size="lg"
      title="Invite User"
      title-class="font-18"
      hide-footer
      :no-close-on-backdrop="true"
      @hidden="$emit('hidden')"
    >
      <validationObserver ref="createInvite">
        <b-form @submit.prevent="onInviteFormSubmit">
          <validationProvider
            v-slot="{ errors }"
            name="Email"
            :rules="{ dynamicRequired: ['กรุณาระบุอีเมล'] }"
          >
            <b-form-group label="อีเมล" label-for="email" label-cols-sm="3">
              <b-form-input
                id="email"
                type="email"
                v-model="inviteUserModel.email"
                :class="{ 'is-invalid': errors.length }"
                @input="onGetUserInformationByEmail(inviteUserModel.email)"
              ></b-form-input>
              <div v-if="errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </validationProvider>

          <validationProvider
            v-slot="{ errors }"
            name="Name"
            :rules="{ dynamicRequired: ['กรุณาระบุชื่อเป็นภาษาไทย'] }"
          >
            <b-form-group
              class="mb-4"
              label="ชื่อ (ไทย)"
              label-for="first_name"
              label-cols-sm="3"
            >
              <b-form-input
                id="first_name"
                v-model="inviteUserModel.first_name.th"
                :class="{ 'is-invalid': errors.length }"
              ></b-form-input>
              <div v-if="errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </validationProvider>

          <validationProvider
            v-slot="{ errors }"
            name="Last Name"
            :rules="{ dynamicRequired: ['กรุณาระบุนามสกุลเป็นภาษาไทย'] }"
          >
            <b-form-group
              class="mb-4"
              label="นามสกุล (ไทย)"
              label-for="last_name"
              label-cols-sm="3"
            >
              <b-form-input
                id="last_name"
                v-model="inviteUserModel.last_name.th"
                :class="{ 'is-invalid': errors.length }"
              ></b-form-input>
              <div v-if="errors.length" class="validate-invalid">
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </validationProvider>

          <b-form-group
            class="mb-4"
            label="เบอร์โทรศัพท์"
            label-for="phone"
            label-cols-sm="3"
          >
            <b-form-input
              id="phone"
              v-model="inviteUserModel.phone"
            ></b-form-input>
          </b-form-group>

          <button
            type="submit"
            class="btn btn-primary mr-1"
            style="float: right"
          >
            Submit
          </button>
        </b-form>
      </validationObserver>
    </b-modal>

    <b-modal
      id="modal-invite-response"
      size="lg"
      title="Invite User"
      title-class="font-18"
      :no-close-on-backdrop="true"
      ok-only
      @hidden="clearInviteUser"
    >
      <div class="row">
        <div class="col-lg-10">
          <div class="card">
            <div class="card-body" v-if="modalInviteResponseModel.url">
              <h4 class="card-title">เพิ่มผู้ใช้ใหม่</h4>
              <!-- <p class="card-title-desc">
                We added user {{ inviteUserModel.email }} successfully.
              </p> -->
              <p class="card-title-desc">
                ระบบได้ส่งอีเมลตามที่ระบุไว้เรียบร้อยแล้ว
                ถ้าผู้ขายไม่ได้รับอีเมล สามารถคัดลอก Link
                ด้านล่างเพื่อให้ผู้ขายที่ระบุอีเมลไว้เข้าใช้ระบบได้
              </p>

              <div>
                Invite link url
                <div class="input-group">
                  <input
                    id="modalInviteUrl"
                    type="text"
                    class="form-control col-md-11"
                    style="
                      color: #004085;
                      background-color: #cce5ff;
                      border-color: #b8daff;
                    "
                    v-model="modalInviteResponseModel.url"
                    readonly="true"
                  />
                  <button
                    class="input-group-button btn-primary waves-effect waves-light col-md-1"
                    type="button"
                    @click="copyText"
                  >
                    <i class="fas fa-copy"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body" v-else>
              <h4 class="card-title">เพิ่มผู้ใช้ใหม่</h4>
              <!-- <p class="card-title-desc">
                We found user {{ inviteUserModel.email }} already in the other
                vendor. And we just appended the user to the this vendor.
              </p> -->
              <p class="card-title-desc">
                เพิ่มผู้ใช้งานอีเมล
                {{ inviteUserModel.email }}
                เข้าสู่รหัสผู้ขายที่ระบุไว้เรียบร้อยแล้ว
              </p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { FormatQty } from '@/helpers/utils/format-qty.js'

import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import vendorService from '@/helpers/service/vendor-service'
import { eventBus } from '@/main.js'
import { StatusEnum } from '@/enum/vendor.enum.js'
import userService from '@/helpers/service/user-provider'
/**
 * Projects-create component
 */
export default {
  page: {
    title: 'Vendor',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { PageHeader },
  data() {
    return {
      id: '',
      title: 'View',
      mode: 'view',
      openModal: false,
      items: [
        {
          text: 'Home',
          href: '/',
        },
        {
          text: 'Vendor',
          href: '/vendors',
        },
        {
          text: 'View',
          active: true,
        },
      ],
      model: {
        id: null,
        display_name: {
          th: '',
          en: '',
        },
        status: StatusEnum.ACTIVE,
        type: '',
        user: [],
        create_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
        update_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
      },
      inviteUserModel: {
        email: '',
        first_name: { en: '', th: '' },
        last_name: { en: '', th: '' },
        phone: '',
      },
      modalInviteResponseModel: {
        url: '',
        open_Id: '',
      },
      tempUser: { role: '', status: '' },
      indexEdit: 0,
      isValidate: {
        display_name_th: false,
        display_name_en: false,
        user: { email: false, first_name: false, last_name: false },
      },
      userTablefields: [
        {
          key: 'index',
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0)
          },
          label: 'ลำดับ',
          thStyle: 'width:80px',
          sortable: true,
        },
        {
          key: 'display_name_th',
          label: 'ชื่อ-นามสกุล (ไทย)',
          sortable: true,
        },
        {
          key: 'display_name_en',
          label: 'ชื่อ-นามสกุล (อังกฤษ)',
          sortable: true,
        },
        {
          key: 'email',
          label: 'อีเมล',
          sortable: true,
        },
        {
          key: 'status',
          label: 'สถานะ',
          tdClass: 'text-center',
          thStyle: 'width:100px',
          sortable: true,
        },
        // {
        //   key: 'isPimAdmin',
        //   label: 'PIM Admin',
        //   tdClass: 'text-center',
        //   thStyle: 'width:80px',
        //   sortable: true,
        // },
        {
          key: 'action',
          label: 'Action',
          tdClass: 'text-center',
          thStyle: 'width:80px',
        },
      ],
      isStatusDelete: true,
    }
  },
  created() {
    if (this.$route.params.id == 'new') {
      this.mode = 'new'
      this.title = 'New Vendor'
      this.items[2].text = 'New'

      setTimeout(() => {
        document.title = `New Vendor | ${appConfig.description}`
      }, 100)
    } else {
      this.title = 'Vendor Detail'
      this.items[2].text = 'Vendor Detail'
      this.id = this.$route.params.id
      setTimeout(() => {
        document.title = `Vendor Detail | ${appConfig.description}`
      }, 100)
    }
    // if (this.$route.query.mode) {
    //   this.title = "Edit Vendor";
    //   this.items[2].text = "Edit";
    //   this.mode = this.$route.query.mode;
    // }
  },
  mounted() {
    if (this.mode !== 'new') {
      this.getDetail()
    }
  },
  computed: {
    filterUserTablefields() {
      if (!this.isStatusDelete) {
        return this.userTablefields
      } else {
        return this.userTablefields.filter(
          q => !(q.key === 'isPimAdmin' || q.key === 'action')
        )
      }
    },
  },
  methods: {
    async getDetail() {
      let result = await vendorService.getVendorMasterDetailAsync(this.id)
      if (result.status === 200) {
        this.model = result.data
        console.log('th', this.model)
        this.isStatusDelete = this.model.status.toLowerCase() === 'delete'
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    onBack() {
      this.$router.push({
        path: '/vendors',
      })
    },
    onBackToDetail() {
      if (this.mode == 'edit') {
        this.model.users[this.indexEdit].role = this.tempUser.role
        this.model.users[this.indexEdit].status = this.tempUser.status
      }
      this.mode = 'view'
      this.title = 'Vendor Detail'
      this.items[2].text = 'Vendor Detail'
    },
    async onConfirmReset() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            this.model.users[this.indexEdit].role = this.tempUser.role
            this.model.users[this.indexEdit].status = this.tempUser.status
          }
        })
    },
    async onConfirmClearInvite() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการ Reset หน้าจอเป็นค่าเริ่มต้นใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            this.inviteUserModel = {
              email: '',
              first_name: { en: '', th: '' },
              last_name: { en: '', th: '' },
              status: StatusEnum.ACTIVE,
            }
          }
        })
    },
    async onConfirmAddVendorUser() {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการเพิ่มข้อมูล ${
            this.inviteUserModel.email
          } เข้าในระบบของผู้ขาย ${this.model.display_name.th} (${
            this.model.vendor_partners.findIndex(el => el.partner === 'OFM') >=
            0
              ? this.model.vendor_partners[
                  this.model.vendor_partners.findIndex(
                    el => el.partner === 'OFM'
                  )
                ].code
              : ''
          }) ใช่หรือไม่`,
          ''
        )
        .then(result => {
          if (result) {
            this.model.users.push({ email: this.inviteUserModel.email })
            this.onSave()
          }
        })
    },
    changeMode(_mode, index, data) {
      if (_mode == 'edit') {
        this.mode = 'edit'
        this.title = 'Edit User'
        this.items[2].text = 'Edit User'
        this.indexEdit = index
        this.tempUser = { role: data.role, status: data.status }
      } else if (_mode == 'invite') {
        this.mode = 'invite'
        this.title = 'Invite User'
        this.items[2].text = 'Invite User'
      }
    },
    async onSubmit() {
      this.model.users.forEach((element, i) => {
        if (this.indexEdit != i && element.role === 'Admin') {
          this.model.users[i].role = 'User'
        }
      })
      this.$refs.addDataForm.validate().then(async response => {
        if (response) {
          await this.onSave()
        }
      })
    },
    async onSave() {
      let result = await vendorService.updateVendorMasterAsync(
        this.id,
        this.model
      )
      if (result.status && result.status === 204) {
        this.$utils.notification('success', 'แก้ไขข้อมูลสำเร็จ', 1500)
        this.mode = 'view'
        this.getDetail()
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    async onValidateDisplaynameTH() {
      if (
        !(
          this.model.display_name.th.trim() === '' ||
          this.model.display_name.th.trim() === null ||
          this.model.display_name.th.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('nameTh', this.model.display_name.th.trim())
        if (this.mode === 'edit') {
          params.append('id', this.id)
        }
        let result = await vendorService.headVendorMasterAsync(params)
        if (result.status === 200) {
          this.isValidate.display_name_th = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_th = false
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onValidateDisplaynameEN() {
      if (
        !(
          this.model.display_name.en.trim() === '' ||
          this.model.display_name.en.trim() === null ||
          this.model.display_name.en.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('nameEn', this.model.display_name.en.trim())
        if (this.mode === 'edit') {
          params.append('id', this.id)
        }
        let result = await vendorService.headVendorMasterAsync(params)
        if (result.status === 200) {
          this.isValidate.display_name_en = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.display_name_en = false
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async onValidateEmail() {
      if (
        !(
          this.inviteUserModel.email.trim() === '' ||
          this.inviteUserModel.email.trim() === null ||
          this.inviteUserModel.email.trim() === undefined
        )
      ) {
        let params = new URLSearchParams()
        params.append('email', this.inviteUserModel.email.trim())
        let result = await vendorService.headVendorMasterAsync(params)
        if (result.status === 200) {
          this.isValidate.user.email = true
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.user.email = false
        } else if (
          (result.status && result.status !== 500) ||
          (result.response && result.response.status !== 500)
        ) {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async toggleCheckbox(index) {
      this.model.users.forEach((element, i) => {
        if (index != i && element.role === 'Admin') {
          this.model.users[i].role = 'User'
        }
      })

      await this.onSave()
    },
    async onInviteFormSubmit() {
      await this.$refs.createInvite.validate().then(async result => {
        if (result) {
          this.inviteUserModel = {
            email: this.inviteUserModel.email.trim(),
            first_name: {
              en: this.inviteUserModel.first_name.en.trim(),
              th: this.inviteUserModel.first_name.th.trim(),
            },
            last_name: {
              en: this.inviteUserModel.last_name.en.trim(),
              th: this.inviteUserModel.last_name.th.trim(),
            },
            phone: this.inviteUserModel.phone.trim(),
          }
          let requestResult = await vendorService.inviteVendorUserAsync(
            this.id,
            this.inviteUserModel
          )
          if (requestResult.status === 201) {
            this.$utils.notification('success', 'เทียบเชิญสำเร็จ', 1500)
            this.mode = 'view'
            this.getDetail()
            this.$bvModal.show('modal-invite-response')
            this.$bvModal.hide('modal-invite')
            this.modalInviteResponseModel.url = requestResult.data.invite_url
            this.modalInviteResponseModel.open_Id = requestResult.data.open_id
          } else if (
            (requestResult.status && requestResult.status !== 500) ||
            (requestResult.response && requestResult.response.status !== 500)
          ) {
            this.$utils.notificationAck(
              'error',
              requestResult.response.data.message
            )
          }
          // console.log(result);
        }
      })
    },
    clearInviteUser() {
      this.inviteUserModel = {
        email: '',
        first_name: { en: '', th: '' },
        last_name: { en: '', th: '' },
        phone: '',
      }
      this.modalInviteResponseModel = {
        url: '',
        open_Id: '',
      }
    },
    copyText() {
      let input = document.getElementById('modalInviteUrl')
      input.select()
      document.execCommand('copy')
    },
    async resentEmail(user) {
      console.log('user', user)
      let result = await vendorService.resentInviteVendorUserAsync(
        this.id,
        user.id
      )
      if (result.status === 201) {
        // this.$utils.notification('success', 'อีเมลถูกส่งเรียบร้อยแล้ว', 1500)
        this.modalInviteResponseModel.url = result.data.invite_url
        this.inviteUserModel.email = user.email
        this.modalInviteResponseModel.open_Id = result.data.open_id
        this.$bvModal.show('modal-invite-response')
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notificationAck('error', result.response.data.message)
      }
    },
    async removeUser(user) {
      await this.$utils
        .confirmAlertDisplay(
          `ต้องการลบข้อมูล User ท่านนี้ออกจากผู้ขายที่เลือกไว้ใช่หรือไม่?`,
          ''
        )
        .then(async result => {
          if (result) {
            console.log('user', user)
            let result = await vendorService.deleteVendorUserByIdAsync(
              this.id,
              user.id
            )
            if (result.status === 200) {
              this.$utils.notification(
                'success',
                'ดำเนินการเรียบร้อยแล้ว',
                1500
              )
              await this.getDetail()
            } else if (
              (result.status && result.status !== 500) ||
              (result.response && result.response.status !== 500)
            ) {
              this.$utils.notificationAck('error', result.response.data.message)
            }
          }
        })
    },
    async onGetUserInformationByEmail(email) {
      if (email && email !== '') {
        let params = new URLSearchParams()
        params.append('email', email.trim() || '')
        let result = await userService.getUserByEmailAsync(params)
        if (result.status === 200) {
          this.inviteUserModel.first_name.th = result.data.first_name.th.trim()
          this.inviteUserModel.last_name.th = result.data.last_name.th.trim()
          // this.inviteUserModel.phone = result.data.photo[0]
        }
      }
    },
  },
}
</script>
